import { useState } from "react";
import { Field } from "react-final-form";
import { connect } from "react-redux";

import { addAlert } from "@store/app/actions";

const EditReviewModalImages = ({
  addAlert,
  removeExistingImages,
  parseNewImages,
  thumbnailImages,
}) => {
  const [thumbnailImagesList, setThumbnailImagesList] =
    useState(thumbnailImages);
  const [newImages, setNewImages] = useState([]);

  const handleFileUpload = (event) => {
    event.persist();

    let images = [...newImages];

    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      const fileType = file["type"];
      const validImageTypes = ["image/gif", "image/jpeg", "image/png"];

      if (
        !validImageTypes.includes(fileType) ||
        file.name.split(".").find((element) => element === "jfif") ||
        file.name.split(".").find((element) => element === "gif")
      ) {
        addAlert({
          message: `Sunt permise doar fisiere de tipul JPEG, JPG si PNG`,
          variant: "error",
        });
        return;
      }

      if (file.size > 5242880) {
        event.target.value = "";
        addAlert({
          message: `Sunt permise doar fisiere care sunt mai mici de 5 MB`,
          variant: "error",
        });
        return;
      }

      // create img preview object used for display and same file verification
      const imgFile = {
        name: event.target.files[0]["name"],
        objectPreview: URL.createObjectURL(file),
        file,
      };

      // check for duplicate file
      if (thumbnailImagesList.find((item) => item.name === imgFile.name)) {
        // reset event value
        event.target.value = "";
        addAlert({
          message: `Fisier duplicat` + " " + imgFile.name,
          variant: "error",
        });
        return;
      }

      images.push(imgFile);
      setNewImages(images);
      setThumbnailImagesList((prevState) => [...prevState, imgFile]);
      parseNewImages(images);

      event.target.value = "";
    }
  };

  const removeImage = (key) => {
    let imgList = [...thumbnailImagesList];
    const selectedImage = imgList[key];

    if (typeof selectedImage === "string") {
      removeExistingImages(selectedImage);
    }

    if (typeof selectedImage === "object") {
      let newImagesArray = [...newImages];
      const selectedImageKey = newImagesArray.indexOf(selectedImage);
      newImagesArray.splice(selectedImageKey, 1);

      setNewImages(newImagesArray);
      parseNewImages(newImagesArray);
    }

    imgList.splice(key, 1);

    setThumbnailImagesList(imgList);
  };

  return (
    <div className="flex">
      {thumbnailImagesList.length > 0 &&
        thumbnailImagesList.map((item, index) => (
          <div
            key={index}
            className="flex justify-center items-center relative border border-gray-1100 rounded-tr-lg rounded-bl-lg w-[64px] h-[64px] md:w-[80px] md:h-[80px] mr-2"
          >
            <div
              className="absolute ml-16 -mt-2 bg-black text-white rounded-xl cursor-pointer top-0 -right-1"
              onClick={() => removeImage(index)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5  rotate-45"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                />
              </svg>
            </div>

            <label className="flex items-center bg-gray-100 tracking-wide hover:bg-gray-101 w-[60px] h-[60px]">
              <img
                className="rounded-[6px] h-[60px] w-[60px] object-cover"
                src={item.objectPreview || item}
                alt=""
              />
            </label>
          </div>
        ))}

      {thumbnailImagesList.length < 5 && (
        <Field
          name="images"
          render={(props) => (
            <label className="flex items-center justify-center w-[64px] h-[64px] md:w-[80px] md:h-[80px] p-2 border border-gray-1100 rounded-tr-lg rounded-bl-lg cursor-pointer">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-8 h-8"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                />
              </svg>

              <input
                {...props.input}
                id="attachment"
                name="attachment"
                type="file"
                className="hidden"
                // iOS Safari 12 supports only image/* types
                accept="image/jpg,image/png,image/jpeg"
                disabled={thumbnailImagesList.length > 4 ? true : false}
                onChange={handleFileUpload}
              />
            </label>
          )}
        />
      )}
    </div>
  );
};

export default connect(null, { addAlert })(EditReviewModalImages);
